import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { useI18n } from "@/i18n";
import Seo from "@/components/public/Seo";

export default function NotFoundPage() {
  const { t } = useI18n();
  return (
    <>
      <Seo title="الصفحة غير موجودة — ARAN TOOLS" description="الصفحة التي تبحث عنها غير موجودة." noIndex />
      <div className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6" data-testid="not-found-page">
        <div className="font-head text-7xl font-extrabold text-primary/30">404</div>
        <p className="mt-4 text-muted-foreground">الصفحة التي تبحث عنها غير موجودة.</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center gap-2 bg-primary text-primary-foreground rounded-full px-6 py-2.5 font-semibold hover:opacity-90 transition-opacity"
        >
          <Home className="w-4 h-4" />
          {t("home")}
        </Link>
      </div>
    </>
  );
}
